import './App.css';
import Header from './templates/header/Header';
import Imp from './templates/impression/Impression';
import Main from './templates/main/Main';
import Footer from './templates/footer/Footer';
//import Popup from './templates/popup/Popup';

function App() {
  return (
    <div id="wrapper">
      <Header />
      <Imp />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
